/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

type ArrowDirection = 'right' | 'left' | 'up' | 'down';

const degreeMap = {
  right: 270,
  left: 90,
  up: 180,
  down: 0,
};

export const ArrowCircleStatefulIcon = ({
  className,
  color = '#938BB7',
  onClick,
  direction = 'right',
  size = 20,
  style: propStyles,
}: IconTypeProps & {
  direction?: ArrowDirection;
  size?: number;
}) => {
  const style = {
    transform: `rotate(${degreeMap[direction]}deg)`,
    transition: '.3s',
    width: `${size}px`,
    height: `${size}px`,
    ...propStyles,
  };

  return (
    <svg
      className={classNames(className, 'c-arrow-stateful-icon')}
      onClick={onClick}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <circle cx="7" cy="7" r="7" fill={color} />
      <path
        d="M6.64645 11.3536C6.84171 11.5488 7.15829 11.5488 7.35355 11.3536L10.5355 8.17157C10.7308 7.97631 10.7308 7.65973 10.5355 7.46447C10.3403 7.2692 10.0237 7.2692 9.82843 7.46447L7 10.2929L4.17157 7.46447C3.97631 7.2692 3.65973 7.2692 3.46447 7.46447C3.2692 7.65973 3.2692 7.97631 3.46447 8.17157L6.64645 11.3536ZM6.5 3L6.5 11H7.5V3H6.5Z"
        fill="white"
      />
    </svg>
  );
};
